import { Box, Grid } from "@mui/material";

import styles from "../homepage.module.css";
import ClientData from "src/components/DashboardComponents/ClientData/ClientData";
import LatestReport from "src/components/DashboardComponents/LatestReport/LatetsReport";
import PartnerLicenses from "src/components/DashboardComponents/PartnerLicenses/PartnerLicenses";
import CurrentPlan from "src/components/DashboardComponents/CurrentPlan/CurrentPlan";

function DashboardPage() {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Grid container p={{ lg: 4, xs: 3 }} pb={0} flexDirection="row" justifyContent={{ lg: "center", md: "flex-start", xs: "center" }} alignItems="stretch" spacing={2}>
          <CurrentPlan />
          {/* <LatestReport /> */}
          <ClientData />
        </Grid>
      </Box>
      <Grid
        container
        p={{ lg: 4, xs: 3 }}
        pt={{ md: 0, sm: 0, xs: 0 }}
        pb={2}
        flexDirection="row"
        justifyContent={{ lg: "space-between", md: "center", xs: "center" }}
        alignItems="stretch"
        spacing={2}
      >
        <PartnerLicenses />
      </Grid>
    </>
  );
}

export default DashboardPage;
